import { ImagePlus } from "lucide-react";
import { motion } from "framer-motion";

export const PhotoSlot = ({ index, category, label, ratio = "aspect-[4/5]", src }) => (
  <motion.figure
    layout
    initial={{ opacity: 0, scale: 0.96 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.96 }}
    transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    data-testid={`photo-slot-${category.toLowerCase().replace(/\s+/g, "-")}-${index}`}
    className={`group relative ${ratio} overflow-hidden rounded-sm transition-colors duration-500 ${
      src ? "border border-line" : "border border-dashed border-oak/45 bg-sand hover:border-oak"
    }`}
  >
    {src ? (
      <>
        <img
          src={src}
          alt={`${label} · proiect real LOGITEH PROD`}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_35%,transparent_50%,rgba(24,21,18,0.5)_100%)]" />
        <span className="absolute left-4 top-4 rounded-full bg-anthracite/70 px-3 py-1 font-mono text-[9px] uppercase tracking-[0.25em] text-oak backdrop-blur-sm">
          Proiect real
        </span>
        <figcaption className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 bg-gradient-to-t from-anthracite/85 via-anthracite/40 to-transparent p-4 pt-10">
          <span className="font-serif text-lg font-semibold text-cream">{label}</span>
          <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-oak">{category}</span>
        </figcaption>
      </>
    ) : (
      <>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_35%,rgba(200,138,75,0.16),transparent_65%)] transition-opacity duration-500 group-hover:opacity-150" />
        <span className="pointer-events-none absolute -right-3 -top-6 select-none font-serif text-[7rem] font-black leading-none text-walnut/10 transition-colors duration-500 group-hover:text-walnut/20">
          {String(index).padStart(2, "0")}
        </span>
        <figcaption className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center">
          <span className="grid h-14 w-14 place-items-center rounded-full border border-oak/40 bg-white/70 text-walnut transition-transform duration-500 group-hover:scale-110 group-hover:border-oak">
            <ImagePlus size={22} strokeWidth={1.5} />
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-walnut/80">
            {category}
          </span>
          <span className="font-serif text-lg font-semibold text-ink/80">{label}</span>
          <span className="text-xs text-clay">Fotografie reală din atelier · în curând</span>
        </figcaption>
      </>
    )}
    <span className="absolute bottom-0 left-0 z-[2] h-[3px] w-0 bg-oak transition-[width] duration-500 group-hover:w-full" />
  </motion.figure>
);
